// New layers record who made them (Josh, 10 Oct 2026). Step 1 of the layer lock: the maker
// will be able to lock and unlock their own layer. Only NEW layers get this; existing layers
// have no maker and are locked by the owner and administrators.
//
// `creator` is the same field name versions use for their maker. Not yet enforced by the
// rules (that comes with the lock), so read it as "who made it", not as a permission.
export function withCreator(layer, uid, now) {
    const out = { ...layer, createdAt: (now || new Date()).toISOString() };
    if (uid) out.creator = uid;
    return out;
}



// WEBPACK FOOTER //
// ./src/lib/layer-creator.js